import { resetErrorStatus } from "@modules/global";
import { useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Box, Button, Card, CardContent, Alert, Grid } from "@mzc-pdc/ui";
import { IconForward, ImageAccessNot, ImageErrorInfo, ImageNoAccessInfo } from "@mzc-cloudplex/icons";
import Typography from "@components_v2/typography/typography";
import theme from "@styles/theme";
import { alpha } from "@mui/material";
import { siteMode } from "@cores/siteMode";
import menuService from "@services/menuService";

const Error404 = () => {
    const { t } = useTranslation();
    const isLibrary = siteMode.get() === "CMS";

    const handleGoToHome = useCallback(() => {
        window.location.href = isLibrary ? menuService.paths.library.spaces() : menuService.paths.spaces();
    }, []);

    return (
        <Grid container sx={{ justifyContent: "center", alignItems: "center", height: "100%" }}>
            <Card
                sx={{
                    width: 600,
                    textAlign: "center",
                    border: `1px solid ${theme.palette.greySecondary[100]}`,
                    backgroundColor: theme.palette.background.paper,
                }}
            >
                <CardContent sx={{ padding: 4 }}>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            marginBottom: 3,
                        }}
                    >
                        <ImageErrorInfo width={60} height={60} />
                    </Box>

                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: theme.spacing(1.5),
                            my: theme.spacing(4),
                        }}
                    >
                        <Typography variant="h3" gutterBottom color={theme.palette.greySecondary.main}>
                            {t(`common::msg::${"Page not found"}`)}
                        </Typography>

                        <Typography variant={"body1_700"} gutterBottom color={theme.palette.greySecondary[600]}>
                            {t(`common::msg::Please use the button below to go to the start page.`)}
                        </Typography>
                    </Box>
                    <Button
                        variant="contained"
                        color={"primary"}
                        size="medium"
                        endIcon={<IconForward size={20} />}
                        onClick={handleGoToHome}
                        sx={{
                            paddingX: 4,
                            paddingY: 1.5,
                            borderRadius: 2,
                            textTransform: "none",
                            fontSize: "1rem",
                            mb: theme.spacing(6),
                        }}
                    >
                        {t(`common::label::To Start Page`)}
                    </Button>
                </CardContent>
            </Card>
        </Grid>
    );
};

export default Error404;
